function useLocalStorage() {
  const getLocalStorageItem = (itemName: string) => {
    if (typeof window !== 'undefined') {
      const localStorageItem = localStorage.getItem(itemName);
      return typeof localStorageItem == 'string'
        ? JSON.parse(localStorageItem)
        : localStorageItem;
    }
  };

  const setLocalStorageItem = (
    itemName: string,
    itemValue: string | { [key: string]: string },
  ) => {
    if (typeof window !== 'undefined')
      localStorage.setItem(itemName, JSON.stringify(itemValue));
  };

  const removeLocalStorageItem = (itemName: string) => {
    if (typeof window !== 'undefined') localStorage.removeItem(itemName);
  };

  return {
    getLocalStorageItem,
    setLocalStorageItem,
    removeLocalStorageItem,
  };
}

export { useLocalStorage };
